import { createAction } from "@reduxjs/toolkit";
import axios from "axios";
import { call, put, takeEvery } from "redux-saga/effects";
import {
  ADD_REWARDS_TO_CATALOGUE_REQUEST,
  APPROVE_GAMIFICATION_REDEMPTION_REQUEST,
  APPROVING_GAMIFICATION_REDEMPTION_SUCCEEDED,
  APPROVING_GAMIFICATION_REDEMPTION_FAILED,
  CREATE_ACTIVITY_POINT_REQUEST,
  CREATING_ACTIVITY_POINT_SUCCEEDED,
  CREATING_ACTIVITY_POINT_FAILED,
  CREATE_GAMIFICATION_POINT_TRIGGER_REQUEST,
  CREATING_GAMIFICATION_POINT_TRIGGER_SUCCEEDED,
  CREATING_GAMIFICATION_POINT_TRIGGER_FAILED,
  CREATE_REWARD_REQUEST,
  CREATING_REWARD_SUCCEEDED,
  CREATING_REWARD_FAILED,
  DELETE_REWARD_REQUEST,
  DELETING_REWARD_SUCCEEDED,
  DELETING_REWARD_FAILED,
  DISABLE_ACTIVITY_POINT_REQUEST,
  DISABLING_ACTIVITY_POINT_SUCCEEDED,
  DISABLING_ACTIVITY_POINT_FAILED,
  DISABLE_GAMIFICATION_SETTINGS_REWARD_REQUEST,
  DISABLING_GAMIFICATION_SETTINGS_REWARD_SUCCEEDED,
  DISABLING_GAMIFICATION_SETTINGS_REWARD_FAILED,
  FETCH_GAMIFICATION_BALANCE_REQUEST,
  FETCHING_GAMIFICATION_BALANCE_SUCCEEDED,
  FETCHING_GAMIFICATION_BALANCE_FAILED,
  FETCH_GAMIFICATION_LIFETIME_POINTS_REQUEST,
  FETCHING_GAMIFICATION_LIFETIME_POINTS_SUCCEEDED,
  FETCHING_GAMIFICATION_LIFETIME_POINTS_FAILED,
  FETCH_GAMIFICATION_POINT_TRIGGERS_REQUEST,
  FETCHING_GAMIFICATION_POINT_TRIGGERS_SUCCEEDED,
  FETCHING_GAMIFICATION_POINT_TRIGGERS_FAILED,
  FETCH_GAMIFICATION_REDEMPTIONS_REQUEST,
  FETCHING_GAMIFICATION_REDEMPTIONS_SUCCEEDED,
  FETCHING_GAMIFICATION_REDEMPTIONS_FAILED,
  FETCH_GAMIFICATION_REWARDS_REQUEST,
  FETCHING_GAMIFICATION_REWARDS_SUCCEEDED,
  FETCHING_GAMIFICATION_REWARDS_FAILED,
  FETCH_GAMIFICATION_TRANSACTIONS_REQUEST,
  FETCHING_GAMIFICATION_TRANSACTIONS_SUCCEEDED,
  FETCHING_GAMIFICATION_TRANSACTIONS_FAILED,
  FETCH_REWARDS_CATALOGUE_REQUEST,
  FETCHING_REWARDS_CATALOGUE_SUCCEEDED,
  FETCHING_REWARDS_CATALOGUE_FAILED,
  INVALIDATE_CREATE_REWARD_STATE,
  INVALIDATE_DELETE_REWARD_STATE,
  INVALIDATE_GAMIFICATION_REDEMPTION_REVIEW,
  INVALIDATE_GAMIFICATION_REWARD_REDEMPTION,
  MARK_GAMIFICATION_REDEMPTION_GRANTED_REQUEST,
  MARKING_GAMIFICATION_REDEMPTION_GRANTED_SUCCEEDED,
  MARKING_GAMIFICATION_REDEMPTION_GRANTED_FAILED,
  REDEEM_GAMIFICATION_REWARD_REQUEST,
  REDEEMING_GAMIFICATION_REWARD_SUCCEEDED,
  REDEEMING_GAMIFICATION_REWARD_FAILED,
  REJECT_GAMIFICATION_REDEMPTION_REQUEST,
  REJECTING_GAMIFICATION_REDEMPTION_SUCCEEDED,
  REJECTING_GAMIFICATION_REDEMPTION_FAILED,
  UPDATE_GAMIFICATION_POINT_TRIGGER_REQUEST,
  UPDATING_GAMIFICATION_POINT_TRIGGER_SUCCEEDED,
  UPDATING_GAMIFICATION_POINT_TRIGGER_FAILED,
  UPDATE_REWARD_REQUEST,
  UPDATING_REWARD_SUCCEEDED,
  UPDATING_REWARD_FAILED,
  FETCH_USER_GAMIFICATION_REDEMPTIONS_REQUEST,
  FETCH_USER_GAMIFICATION_REDEMPTIONS_SUCCEEDED,
  FETCH_USER_GAMIFICATION_REDEMPTIONS_FAILED,
} from "../actionTypes";
import {
  AddRewardsRequest,
  ApproveGamificationRedemptionRequest,
  ApproveGamificationRedemptionResponse,
  ApproveGamificationRedemptionErrorResponse,
  CreateActivityPointRequest,
  CreateActivityPointResponse,
  CreateActivityPointErrorResponse,
  CreateGamificationPointTriggerRequest,
  CreateGamificationPointTriggerResponse,
  CreateGamificationPointTriggerErrorResponse,
  CreateRewardRequest,
  CreateRewardResponse,
  CreateRewardErrorResponse,
  DeleteRewardRequest,
  DeleteRewardResponse,
  DeleteRewardErrorResponse,
  DisableActivityPointRequest,
  DisableActivityPointResponse,
  DisableActivityPointErrorResponse,
  DisableGamificationSettingsRewardRequest,
  DisableGamificationSettingsRewardResponse,
  DisableGamificationSettingsRewardErrorResponse,
  FetchGamificationBalanceResponse,
  FetchGamificationBalanceErrorResponse,
  FetchGamificationLifetimePointsResponse,
  FetchGamificationLifetimePointsErrorResponse,
  FetchGamificationPointTriggersResponse,
  FetchGamificationPointTriggersErrorResponse,
  FetchGamificationRedemptionsRequest,
  FetchGamificationRedemptionsResponse,
  FetchGamificationRedemptionsErrorResponse,
  FetchGamificationRewardsRequest,
  FetchGamificationRewardsResponse,
  FetchGamificationRewardsErrorResponse,
  FetchGamificationTransactionsResponse,
  FetchGamificationTransactionsErrorResponse,
  FetchRewardsCatalogueRequest,
  FetchRewardsCatalogueResponse,
  FetchRewardsCatalogueErrorResponse,
  MarkGamificationRedemptionGrantedRequest,
  MarkGamificationRedemptionGrantedResponse,
  MarkGamificationRedemptionGrantedErrorResponse,
  RedeemGamificationRewardRequest,
  RedeemGamificationRewardResponse,
  RedeemGamificationRewardErrorResponse,
  RejectGamificationRedemptionRequest,
  RejectGamificationRedemptionResponse,
  RejectGamificationRedemptionErrorResponse,
  UpdateGamificationPointTriggerRequest,
  UpdateGamificationPointTriggerResponse,
  UpdateGamificationPointTriggerErrorResponse,
  UpdateRewardRequest,
  UpdateRewardResponse,
  UpdateRewardErrorResponse,
} from "src/types/coaching/gamification";
import buildUrl from "build-url-ts";

// eslint-disable-next-line no-undef
const apiUrl = `${process.env.REACT_APP_COACHING_API_URL}`;

export const fetchGamificationBalance = createAction<void>(FETCH_GAMIFICATION_BALANCE_REQUEST);
const fetchingGamificationBalanceSucceeded = createAction<FetchGamificationBalanceResponse>(FETCHING_GAMIFICATION_BALANCE_SUCCEEDED);
const fetchingGamificationBalanceFailed = createAction<FetchGamificationBalanceErrorResponse>(FETCHING_GAMIFICATION_BALANCE_FAILED);

const fetchGamificationBalanceSaga = function* (): any {
  const url = buildUrl(apiUrl, {
    path: "api/1.0/gamification/balance",
  });

  const fetchGamificationBalanceAPI = () => {
    return axios({
      method: "GET",
      url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchGamificationBalanceAPI);
    yield put(fetchingGamificationBalanceSucceeded({ response }));
  } catch (error) {
    yield put(fetchingGamificationBalanceFailed({ error }));
  }
};

export const fetchGamificationLifetimePoints = createAction<void>(FETCH_GAMIFICATION_LIFETIME_POINTS_REQUEST);
const fetchingGamificationLifetimePointsSucceeded = createAction<FetchGamificationLifetimePointsResponse>(FETCHING_GAMIFICATION_LIFETIME_POINTS_SUCCEEDED);
const fetchingGamificationLifetimePointsFailed = createAction<FetchGamificationLifetimePointsErrorResponse>(FETCHING_GAMIFICATION_LIFETIME_POINTS_FAILED);

const fetchGamificationLifetimePointsSaga = function* (): any {
  const url = buildUrl(apiUrl, {
    path: "api/1.0/gamification/lifetime-points",
  });

  const fetchGamificationLifetimePointsAPI = () => {
    return axios({
      method: "GET",
      url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchGamificationLifetimePointsAPI);
    yield put(fetchingGamificationLifetimePointsSucceeded({ response }));
  } catch (error) {
    yield put(fetchingGamificationLifetimePointsFailed({ error }));
  }
};

export const fetchGamificationTransactions = createAction<void>(FETCH_GAMIFICATION_TRANSACTIONS_REQUEST);
const fetchingGamificationTransactionsSucceeded = createAction<FetchGamificationTransactionsResponse>(FETCHING_GAMIFICATION_TRANSACTIONS_SUCCEEDED);
const fetchingGamificationTransactionsFailed = createAction<FetchGamificationTransactionsErrorResponse>(FETCHING_GAMIFICATION_TRANSACTIONS_FAILED);

const fetchGamificationTransactionsSaga = function* (): any {
  const url = buildUrl(apiUrl, {
    path: "api/1.0/gamification/transactions",
  });

  const fetchGamificationTransactionsAPI = () => {
    return axios({
      method: "GET",
      url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchGamificationTransactionsAPI);
    yield put(fetchingGamificationTransactionsSucceeded({ response }));
  } catch (error) {
    yield put(fetchingGamificationTransactionsFailed({ error }));
  }
};

export const fetchRewardsCatalogue = createAction<FetchRewardsCatalogueRequest>(FETCH_REWARDS_CATALOGUE_REQUEST);
const fetchingRewardsCatalogueSucceeded = createAction<FetchRewardsCatalogueResponse>(FETCHING_REWARDS_CATALOGUE_SUCCEEDED);
const fetchingRewardsCatalogueFailed = createAction<FetchRewardsCatalogueErrorResponse>(FETCHING_REWARDS_CATALOGUE_FAILED);

const fetchRewardsCatalogueSaga = function* (action: ReturnType<typeof fetchRewardsCatalogue>): any {
  const request = action.payload;

  const params = {
    page: request.page,
    limit: request.limit,
    query: request.query,
  };

  const fetchRewardsCatalogueAPI = () => {
    return axios({
      method: "GET",
      url: buildUrl(apiUrl, {
        path: "api/1.0/gamification/rewards",
      }),
      params,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchRewardsCatalogueAPI);
    yield put(fetchingRewardsCatalogueSucceeded({ response }));
  } catch (error) {
    yield put(fetchingRewardsCatalogueFailed({ error }));
  }
};

export const redeemGamificationReward = createAction<RedeemGamificationRewardRequest>(REDEEM_GAMIFICATION_REWARD_REQUEST);
const redeemingGamificationRewardSucceeded = createAction<RedeemGamificationRewardResponse>(REDEEMING_GAMIFICATION_REWARD_SUCCEEDED);
const redeemingGamificationRewardFailed = createAction<RedeemGamificationRewardErrorResponse>(REDEEMING_GAMIFICATION_REWARD_FAILED);

const redeemGamificationRewardSaga = function* (action: ReturnType<typeof redeemGamificationReward>): any {
  const { rewardId } = action.payload;
  const url = buildUrl(apiUrl, {
    path: `api/1.0/gamification/rewards/${rewardId}/redeem`,
  });

  const redeemGamificationRewardAPI = () => {
    return axios({
      method: "POST",
      url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(redeemGamificationRewardAPI);
    yield put(redeemingGamificationRewardSucceeded({ rewardId, response }));
  } catch (error) {
    yield put(redeemingGamificationRewardFailed({ rewardId, error }));
  }
};

export const invalidateGamificationRewardRedemption = createAction<void>(
  INVALIDATE_GAMIFICATION_REWARD_REDEMPTION,
);


export const markGamificationRedemptionGranted = createAction<MarkGamificationRedemptionGrantedRequest>(MARK_GAMIFICATION_REDEMPTION_GRANTED_REQUEST);
const markingGamificationRedemptionGrantedSucceeded = createAction<MarkGamificationRedemptionGrantedResponse>(MARKING_GAMIFICATION_REDEMPTION_GRANTED_SUCCEEDED);
const markingGamificationRedemptionGrantedFailed = createAction<MarkGamificationRedemptionGrantedErrorResponse>(MARKING_GAMIFICATION_REDEMPTION_GRANTED_FAILED);

const markGamificationRedemptionGrantedSaga = function* (action: ReturnType<typeof markGamificationRedemptionGranted>): any {
  const { id } = action.payload;
  const url = buildUrl(apiUrl, {
    path: `api/1.0/gamification/redemptions/${id}/granted`,
  });

  const markGamificationRedemptionGrantedAPI = () => {
    return axios({
      method: "PUT",
      url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(markGamificationRedemptionGrantedAPI);
    yield put(markingGamificationRedemptionGrantedSucceeded({ id, response }));
  } catch (error) {
    yield put(markingGamificationRedemptionGrantedFailed({ id, error }));
  }
};

export const fetchGamificationRedemptions = createAction<FetchGamificationRedemptionsRequest>(FETCH_GAMIFICATION_REDEMPTIONS_REQUEST);
const fetchingGamificationRedemptionsSucceeded = createAction<FetchGamificationRedemptionsResponse>(FETCHING_GAMIFICATION_REDEMPTIONS_SUCCEEDED);

const fetchingGamificationRedemptionsFailed = createAction<FetchGamificationRedemptionsErrorResponse>(FETCHING_GAMIFICATION_REDEMPTIONS_FAILED);

const fetchGamificationRedemptionsSaga = function* (action: ReturnType<typeof fetchGamificationRedemptions>): any {
  const { page, limit } = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/gamification/settings/redemptions`,
  });

  const fetchGamificationRedemptionsApi = () => {
    return axios({
      method: "GET",
      url: url,
      params: {
        page,
        limit,
      },
    }).then((result) => result.data);
  };
  try {
    const response = yield call(fetchGamificationRedemptionsApi);
    yield put(fetchingGamificationRedemptionsSucceeded({ response }));
  } catch (error) {
    yield put(fetchingGamificationRedemptionsFailed({ error }));
  }
};

export const approveGamificationRedemption = createAction<ApproveGamificationRedemptionRequest>(APPROVE_GAMIFICATION_REDEMPTION_REQUEST);
const approvingGamificationRedemptionSucceeded = createAction<ApproveGamificationRedemptionResponse>(APPROVING_GAMIFICATION_REDEMPTION_SUCCEEDED);
const approvingGamificationRedemptionFailed = createAction<ApproveGamificationRedemptionErrorResponse>(APPROVING_GAMIFICATION_REDEMPTION_FAILED);

const approveGamificationRedemptionSaga = function* (
  action: ReturnType<typeof approveGamificationRedemption>,
): any {
  const { id } = action.payload;
  try {
    const response = yield call(() =>
      axios
        .put(`${apiUrl}/api/1.0/gamification/settings/redemptions/${id}/approve`)
        .then((result) => result.data),
    );
    yield put(approvingGamificationRedemptionSucceeded({ id, response }));
  } catch (error) {
    yield put(approvingGamificationRedemptionFailed({ id, error }));
  }
};

export const rejectGamificationRedemption = createAction<RejectGamificationRedemptionRequest>(REJECT_GAMIFICATION_REDEMPTION_REQUEST);
const rejectingGamificationRedemptionSucceeded = createAction<RejectGamificationRedemptionResponse>(REJECTING_GAMIFICATION_REDEMPTION_SUCCEEDED);
const rejectingGamificationRedemptionFailed = createAction<RejectGamificationRedemptionErrorResponse>(REJECTING_GAMIFICATION_REDEMPTION_FAILED);

const rejectGamificationRedemptionSaga = function* (
  action: ReturnType<typeof rejectGamificationRedemption>,
): any {
  const { id, rejectionReason } = action.payload;
  try {
    const response = yield call(() =>
      axios
        .put(`${apiUrl}/api/1.0/gamification/settings/redemptions/${id}/reject`, {
          rejectionReason,
        })
        .then((result) => result.data),
    );
    yield put(rejectingGamificationRedemptionSucceeded({ id, response }));
  } catch (error) {
    yield put(rejectingGamificationRedemptionFailed({ id, error }));
  }
};

export const invalidateGamificationRedemptionReview = createAction<void>(
  INVALIDATE_GAMIFICATION_REDEMPTION_REVIEW,
);

export const fetchGamificationPointTriggers = createAction<void>(FETCH_GAMIFICATION_POINT_TRIGGERS_REQUEST);
const fetchingGamificationPointTriggersSucceeded = createAction<FetchGamificationPointTriggersResponse>(FETCHING_GAMIFICATION_POINT_TRIGGERS_SUCCEEDED);
const fetchingGamificationPointTriggersFailed = createAction<FetchGamificationPointTriggersErrorResponse>(FETCHING_GAMIFICATION_POINT_TRIGGERS_FAILED);

const fetchGamificationPointTriggersSaga = function* (): any {
  const url = buildUrl(apiUrl, {
    path: "api/1.0/gamification/settings/triggers",
  });
  const fetchGamificationPointTriggersAPI = () => {
    return axios({
      method: "GET",
      url: url,
    }).then((response) => response.data);
  };
  try {
    const response = yield call(fetchGamificationPointTriggersAPI);
    yield put(fetchingGamificationPointTriggersSucceeded({ response }));
  } catch (error) {
    yield put(fetchingGamificationPointTriggersFailed({ error }));
  }
};

export const createGamificationPointTrigger = createAction<CreateGamificationPointTriggerRequest>(
  CREATE_GAMIFICATION_POINT_TRIGGER_REQUEST,
);
const creatingGamificationPointTriggerSucceeded = createAction<CreateGamificationPointTriggerResponse>(CREATING_GAMIFICATION_POINT_TRIGGER_SUCCEEDED);
const creatingGamificationPointTriggerFailed = createAction<CreateGamificationPointTriggerErrorResponse>(CREATING_GAMIFICATION_POINT_TRIGGER_FAILED);

const createGamificationPointTriggerSaga = function* (
  action: ReturnType<typeof createGamificationPointTrigger>,
): any {
  const payload = action.payload as CreateGamificationPointTriggerRequest;
  const url = buildUrl(apiUrl, {
    path: "api/1.0/gamification/settings/triggers",
  });
  const createGamificationPointTriggerAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: payload,
    }).then((response) => response.data);
  };
  try {
    const response = yield call(createGamificationPointTriggerAPI);
    yield put(creatingGamificationPointTriggerSucceeded({ response }));
  } catch (error) {
    yield put(creatingGamificationPointTriggerFailed({ error }));
  }
};

export const updateGamificationPointTrigger = createAction<UpdateGamificationPointTriggerRequest>(UPDATE_GAMIFICATION_POINT_TRIGGER_REQUEST);
const updatingGamificationPointTriggerSucceeded = createAction<UpdateGamificationPointTriggerResponse>(UPDATING_GAMIFICATION_POINT_TRIGGER_SUCCEEDED);
const updatingGamificationPointTriggerFailed = createAction<UpdateGamificationPointTriggerErrorResponse>(UPDATING_GAMIFICATION_POINT_TRIGGER_FAILED);

const updateGamificationPointTriggerSaga = function* (action: ReturnType<typeof updateGamificationPointTrigger>): any {
  const { id, ...body } = action.payload as UpdateGamificationPointTriggerRequest;
  const url = buildUrl(apiUrl, {
    path: `api/1.0/gamification/settings/triggers/${id}`,
  });

  const updateGamificationPointTriggerAPI = () => {
    return axios({
      method: "PUT",
      url,
      data: body,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateGamificationPointTriggerAPI);
    yield put(updatingGamificationPointTriggerSucceeded({ id, response }));
  } catch (error) {
    yield put(updatingGamificationPointTriggerFailed({ id, error }));
  }
};

export const disableGamificationSettingsReward = createAction<DisableGamificationSettingsRewardRequest>(DISABLE_GAMIFICATION_SETTINGS_REWARD_REQUEST);
const disablingGamificationSettingsRewardSucceeded = createAction<DisableGamificationSettingsRewardResponse>(DISABLING_GAMIFICATION_SETTINGS_REWARD_SUCCEEDED);
const disablingGamificationSettingsRewardFailed = createAction<DisableGamificationSettingsRewardErrorResponse>(DISABLING_GAMIFICATION_SETTINGS_REWARD_FAILED);

const disableGamificationSettingsRewardSaga = function* (action: ReturnType<typeof disableGamificationSettingsReward>): any {
  const { id } = action.payload as DisableGamificationSettingsRewardRequest;
  const url = buildUrl(apiUrl, {
    path: `api/1.0/gamification/settings/rewards/${id}/disable`,
  });

  const disableGamificationSettingsRewardAPI = () => {
    return axios({
      method: "PUT",
      url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(disableGamificationSettingsRewardAPI);
    yield put(disablingGamificationSettingsRewardSucceeded({ id, response }));
  } catch (error) {
    yield put(disablingGamificationSettingsRewardFailed({ id, error }));
  }
};

export const disableActivityPoint = createAction<DisableActivityPointRequest>(DISABLE_ACTIVITY_POINT_REQUEST);
const disablingActivityPointSucceeded = createAction<DisableActivityPointResponse>(DISABLING_ACTIVITY_POINT_SUCCEEDED);
const disablingActivityPointFailed = createAction<DisableActivityPointErrorResponse>(DISABLING_ACTIVITY_POINT_FAILED);

const disableActivityPointSaga = function* (
  action: ReturnType<typeof disableActivityPoint>,
): any {
  const { id } = action.payload;
  const url = buildUrl(apiUrl, {
    path: `api/1.0/gamification/settings/triggers/${id}`,
  });
  const disableActivityPointAPI = () => {
    return axios({
      method: "DELETE",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(disableActivityPointAPI);
    yield put(disablingActivityPointSucceeded({ id, response }));
  } catch (error) {
    yield put(disablingActivityPointFailed({ id, error }));
  }
};

export const createActivityPoint = createAction<CreateActivityPointRequest>(CREATE_ACTIVITY_POINT_REQUEST);
const creatingActivityPointSucceeded = createAction<CreateActivityPointResponse>(CREATING_ACTIVITY_POINT_SUCCEEDED);
const creatingActivityPointFailed = createAction<CreateActivityPointErrorResponse>(CREATING_ACTIVITY_POINT_FAILED);

const createActivityPointSaga = function* (
  action: ReturnType<typeof createActivityPoint>,
): any {
  const payload = action.payload as CreateActivityPointRequest;
  const url = buildUrl(apiUrl, {
    path: "api/1.0/gamification/settings/triggers",
  });

  const createActivityPointAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: payload,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createActivityPointAPI);
    yield put(creatingActivityPointSucceeded({ response }));
  } catch (error) {
    yield put(creatingActivityPointFailed({ error }));
  }
};

export const createReward = createAction<CreateRewardRequest>(CREATE_REWARD_REQUEST);
const creatingRewardSucceeded = createAction<CreateRewardResponse>(CREATING_REWARD_SUCCEEDED);
const creatingRewardFailed = createAction<CreateRewardErrorResponse>(CREATING_REWARD_FAILED);

const createRewardSaga = function* (action: ReturnType<typeof createReward>): any {
  const payload = action.payload as CreateRewardRequest;
  const url = buildUrl(apiUrl, {
    path: "api/1.0/gamification/settings/rewards",
  });

  const createRewardAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: payload,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createRewardAPI);
    yield put(creatingRewardSucceeded({ response }));
  } catch (error) {
    yield put(creatingRewardFailed({ error }));
  }
};

export const updateReward = createAction<UpdateRewardRequest>(UPDATE_REWARD_REQUEST);
const updatingRewardSucceeded = createAction<UpdateRewardResponse>(UPDATING_REWARD_SUCCEEDED);
const updatingRewardFailed = createAction<UpdateRewardErrorResponse>(UPDATING_REWARD_FAILED);

const updateRewardSaga = function* (action: ReturnType<typeof updateReward>): any {
  const { id, ...body } = action.payload as UpdateRewardRequest;
  const url = buildUrl(apiUrl, {
    path: `api/1.0/gamification/settings/rewards/${id}`,
  });

  const updateRewardAPI = () => {
    return axios({
      method: "PUT",
      url,
      data: body,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateRewardAPI);
    yield put(updatingRewardSucceeded({ id, response }));
  } catch (error) {
    yield put(updatingRewardFailed({ id, error }));
  }
};

export const deleteReward = createAction<DeleteRewardRequest>(DELETE_REWARD_REQUEST);
const deletingRewardSucceeded = createAction<DeleteRewardResponse>(DELETING_REWARD_SUCCEEDED);
const deletingRewardFailed = createAction<DeleteRewardErrorResponse>(DELETING_REWARD_FAILED);

const deleteRewardSaga = function* (action: ReturnType<typeof deleteReward>): any {
  const { id } = action.payload as DeleteRewardRequest;
  const url = buildUrl(apiUrl, {
    path: `api/1.0/gamification/settings/rewards/${id}`,
  });

  const deleteRewardAPI = () => {
    return axios({
      method: "DELETE",
      url,
    }).then(() => undefined);
  };

  try {
    yield call(deleteRewardAPI);
    yield put(deletingRewardSucceeded({ id }));
  } catch (error) {
    yield put(deletingRewardFailed({ id, error }));
  }
};

export const invalidateDeleteRewardState = createAction<string>(INVALIDATE_DELETE_REWARD_STATE);

export const invalidateCreateRewardState = createAction<void>(INVALIDATE_CREATE_REWARD_STATE);

export const addRewardsToCatalogue = createAction<AddRewardsRequest>(ADD_REWARDS_TO_CATALOGUE_REQUEST);

export const fetchGamificationRewards = createAction<FetchGamificationRewardsRequest>(FETCH_GAMIFICATION_REWARDS_REQUEST);
const fetchingGamificationRewardsSucceeded = createAction<FetchGamificationRewardsResponse>(FETCHING_GAMIFICATION_REWARDS_SUCCEEDED);
const fetchingGamificationRewardsFailed = createAction<FetchGamificationRewardsErrorResponse>(FETCHING_GAMIFICATION_REWARDS_FAILED);

const fetchGamificationRewardsSaga = function* (action: ReturnType<typeof fetchGamificationRewards>): any {
  const { page, limit, query } = action.payload as FetchGamificationRewardsRequest;

  const url = buildUrl(apiUrl, {
    path: "api/1.0/gamification/settings/rewards",
  });

  const fetchRewardsAPI = () => {
    return axios({
      method: "GET",
      url: url,
      params: {
        page: page,
        limit: limit,
        query: query,
      },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchRewardsAPI);
    yield put(fetchingGamificationRewardsSucceeded({ response }));
  } catch (error) {
    yield put(fetchingGamificationRewardsFailed({ error }));
  }
};

export const fetchGamificationRedemptionsForUser = createAction<FetchGamificationRedemptionsRequest>(FETCH_USER_GAMIFICATION_REDEMPTIONS_REQUEST);
const fetchingGamificationRedemptionsForUserSucceeded = createAction<FetchGamificationRedemptionsResponse>(FETCH_USER_GAMIFICATION_REDEMPTIONS_SUCCEEDED);
const fetchingGamificationRedemptionsForUserFailed = createAction<FetchGamificationRedemptionsErrorResponse>(FETCH_USER_GAMIFICATION_REDEMPTIONS_FAILED);

const fetchGamificationRedemptionsForUserSaga = function* (action: ReturnType<typeof fetchGamificationRedemptionsForUser>): any {
  const { page, limit } = action.payload;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/gamification/redemptions`,
  });

  const fetchGamificationRedemptionsForUserApi = () => {
    return axios({
      method: "GET",
      url: url,
      params: {
        page,
        limit,
      },
    }).then((result) => result.data);
  };
  try {
    const response = yield call(fetchGamificationRedemptionsForUserApi);
    yield put(fetchingGamificationRedemptionsForUserSucceeded({ response }));
  } catch (error) {
    yield put(fetchingGamificationRedemptionsForUserFailed({ error }));
  }
};


export default function* gamificationSaga() {
  yield takeEvery(FETCH_GAMIFICATION_BALANCE_REQUEST, fetchGamificationBalanceSaga);
  yield takeEvery(FETCH_GAMIFICATION_LIFETIME_POINTS_REQUEST, fetchGamificationLifetimePointsSaga);
  yield takeEvery(FETCH_GAMIFICATION_TRANSACTIONS_REQUEST, fetchGamificationTransactionsSaga);
  yield takeEvery(FETCH_REWARDS_CATALOGUE_REQUEST, fetchRewardsCatalogueSaga);
  yield takeEvery(REDEEM_GAMIFICATION_REWARD_REQUEST, redeemGamificationRewardSaga);
  yield takeEvery(FETCH_GAMIFICATION_REDEMPTIONS_REQUEST, fetchGamificationRedemptionsSaga);
  yield takeEvery(MARK_GAMIFICATION_REDEMPTION_GRANTED_REQUEST, markGamificationRedemptionGrantedSaga);
  yield takeEvery(APPROVE_GAMIFICATION_REDEMPTION_REQUEST, approveGamificationRedemptionSaga);
  yield takeEvery(REJECT_GAMIFICATION_REDEMPTION_REQUEST, rejectGamificationRedemptionSaga);
  yield takeEvery(FETCH_GAMIFICATION_POINT_TRIGGERS_REQUEST, fetchGamificationPointTriggersSaga);
  yield takeEvery(CREATE_GAMIFICATION_POINT_TRIGGER_REQUEST, createGamificationPointTriggerSaga);
  yield takeEvery(UPDATE_GAMIFICATION_POINT_TRIGGER_REQUEST, updateGamificationPointTriggerSaga);
  yield takeEvery(DISABLE_GAMIFICATION_SETTINGS_REWARD_REQUEST, disableGamificationSettingsRewardSaga);
  yield takeEvery(CREATE_REWARD_REQUEST, createRewardSaga);
  yield takeEvery(DISABLE_ACTIVITY_POINT_REQUEST, disableActivityPointSaga);
  yield takeEvery(CREATE_ACTIVITY_POINT_REQUEST, createActivityPointSaga);
  yield takeEvery(FETCH_GAMIFICATION_REWARDS_REQUEST, fetchGamificationRewardsSaga);
  yield takeEvery(UPDATE_REWARD_REQUEST, updateRewardSaga);
  yield takeEvery(DELETE_REWARD_REQUEST, deleteRewardSaga);
  yield takeEvery(FETCH_USER_GAMIFICATION_REDEMPTIONS_REQUEST, fetchGamificationRedemptionsForUserSaga );
}
